import React from 'react';
import { Container } from 'react-pixi-fiber';
import { TilemapTileHighlight } from './tilemap-tile-highlight';
import { tileInfosGetter } from './utils/tile-infos-getter';
export var TilemapTilesStates = function (_a) {
    var mapSheet = _a.mapSheet, backgroundLayer = _a.backgroundLayer, tilesRange = _a.tilesRange, tilesAction = _a.tilesAction, tilesCurrentAction = _a.tilesCurrentAction;
    var getTileInfos = tileInfosGetter({ mapSheet: mapSheet, layer: backgroundLayer });
    var layerName = 'tile-states';
    return (React.createElement(Container, null, backgroundLayer.data
        .map(function (id, index) {
        var tileInfos = getTileInfos(id, index);
        if (!tileInfos) {
            return null;
        }
        var worldPos = tileInfos.worldPos, tilePos = tileInfos.tilePos, tileset = tileInfos.tileset;
        return React.createElement(Container, { key: layerName + ':' + worldPos.x + ':' + worldPos.y, x: worldPos.x, y: worldPos.y },
            React.createElement(TilemapTileHighlight, { isRange: tilesRange[tilePos.id], isAction: tilesAction[tilePos.id], isCurrentAction: tilesCurrentAction[tilePos.id], size: tileset.tileheight }));
    })));
};
